import type { SVGProps } from "react";

export const ZohoBooks = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className="logo-color"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Zoho books</title>
    <path
      d="M729.54 1024H30c-16.57 0-30-13.43-30-30V739.84c0-55.52 35.28-104.93 87.8-122.96l775.28-266.09C923.44 330.07 964 273.26 964 209.44 964 127.04 896.96 60 814.56 60H60v494.96c0 16.57-13.43 30-30 30s-30-13.43-30-30V30C0 13.43 13.43 0 30 0h784.56C930.05 0 1024 93.95 1024 209.44c0 89.45-56.84 169.06-141.45 198.1L107.28 673.63C79 683.33 60 709.94 60 739.84V964h669.54c62.63 0 121.5-24.39 165.79-68.67C939.61 851.04 964 792.17 964 729.54c0-44.33-12.49-87.56-36.11-125.02-23.39-37.1-56.55-66.79-95.89-85.88-14.91-7.23-21.13-25.18-13.89-40.09 7.23-14.91 25.18-21.13 40.09-13.89 49.42 23.98 91.07 61.28 120.45 107.86 29.68 47.06 45.36 101.36 45.36 157.03 0 78.65-30.63 152.6-86.25 208.22-55.62 55.6-129.57 86.23-208.22 86.23z"
      fill="#226eb3"
      opacity=".9"
    />
    <path
      d="M337.52 419.82c-66.17 0-120-53.83-120-120s53.83-120 120-120 120 53.83 120 120-53.83 120-120 120zm0-180c-33.08 0-60 26.92-60 60s26.92 60 60 60 60-26.92 60-60-26.92-60-60-60zM638.34 843.53c-66.17 0-120-53.83-120-120s53.83-120 120-120 120 53.83 120 120-53.83 120-120 120zm0-180c-33.08 0-60 26.92-60 60s26.92 60 60 60 60-26.92 60-60-26.92-60-60-60z"
      fill="#226eb3"
      opacity=".9"
    />
  </svg>
);

export default ZohoBooks;
